import { ResidentItem, ResidentStatus } from '@lmc/ts-common'
import { Tag } from '@lmc/ui-kit'
import useHomeType from 'hooks/useHomeType'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type ProfileBadgesProps = { resident: ResidentItem }

export const ProfileBadges = ({ resident }: ProfileBadgesProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const { isDoLSOverride } = useHomeType()

  const hasAllergies = resident.residentAllergies?.length > 0

  const hasNoKnownAllergies = resident?.noKnownAllergies === true

  const isDummy = resident.status === ResidentStatus.dummy

  return (
    <StyledBadges>
      {isDummy && <Tag>{t(supConstants.DUMMY)}</Tag>}
      {(hasAllergies || hasNoKnownAllergies) && (
        <Tag color="green">
          {t(
            supConstants[
              hasNoKnownAllergies ? 'NO_KNOWN_ALLERGIES' : 'ALLERGIES'
            ]
          ).toUpperCase()}
        </Tag>
      )}
      {resident.dnacpr && (
        <Tag color="red">{t(supConstants.DNACPR).toUpperCase()}</Tag>
      )}
      {resident.hasChokingRisk && (
        <Tag color="orange">{t(supConstants.CHOKING_RISK).toUpperCase()}</Tag>
      )}
      {resident.dols && (
        <Tag color="blue">
          {isDoLSOverride ? t(supConstants.DOLS) : t(supConstants.LPS)}
        </Tag>
      )}
    </StyledBadges>
  )
}

const StyledBadges = styled.div`
  display: flex;
  padding-top: 8px;
  height: fit-content;
`
